<template>
	<hr class="divider-line" :class="customClass" :style="customStyle"/>
</template>

<script>
export default {
	name: 'Divider',
	props: {
		color: {
			type: String,
		},
		thickness: {
			type: String,
		},
		customClass: {
			type: String,
			default: ''
		}
	},
	computed: {
		customStyle() {
			return {
				border: 'none',
				height: this.thickness,
				backgroundColor: this.color,
				margin: '1rem 0'
			}
		}
	}
}
</script>

<style scoped>
.divider-line {
	forced-color-adjust: none;
	-webkit-forced-color-adjust: none;
	border: none;
	height: 0.06rem;
	background: linear-gradient(to right, transparent, var(--color-subtle), transparent);
}
</style>
